import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { AdviserChat } from '@/features/adviser-chat'
import { useAdviserAnalytics } from '@/features/adviser-chat/analytics'
import { useOpenHavenFromQueryParam } from '@/features/adviser-chat/hooks/useOpenHavenFromQueryParam'
import { isAdviserHiddenRoute } from '@/features/adviser-chat/lib/hiddenRoutes'

export const AdviserWidget = () => {
  useOpenHavenFromQueryParam()
  const { pathname, search } = useLocation()
  const { trackWidgetDisplayed } = useAdviserAnalytics()
  const wasVisibleRef = useRef(false)

  const isHidden = isAdviserHiddenRoute(`${pathname}${search}`)

  useEffect(() => {
    if (!isHidden && !wasVisibleRef.current) {
      trackWidgetDisplayed()
      wasVisibleRef.current = true
    } else if (isHidden) {
      wasVisibleRef.current = false
    }
  }, [isHidden, trackWidgetDisplayed])

  if (isHidden) return null

  return <AdviserChat />
}
